import { render, staticRenderFns } from "./Dividend-s2.vue?vue&type=template&id=05759e30&scoped=true"
import script from "./Dividend-s2.vue?vue&type=script&lang=js"
export * from "./Dividend-s2.vue?vue&type=script&lang=js"
import style0 from "./Dividend-s2.vue?vue&type=style&index=0&id=05759e30&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05759e30",
  null
  
)

export default component.exports